const env = process.env.NODE_ENV === "development" ? "dev" : "prod";
const config = require(`./config.${env}.json`);

export default config;
